import React from "react";
import { connect } from 'react-redux';
import { Row, Col, Nav, NavItem, NavLink } from "reactstrap";

const Footer = (props) => {
  return (
    <footer className={"footer lbg-"+props.theme}>
      <Row className="align-items-center justify-content-xl-between">
        <Col xl="6">
          <div className="copyright text-center text-xl-left text-muted">
            © {new Date().getFullYear()}{" "}
            <a
              className="font-weight-bold ml-1"
              href="/info"
              target="_blank"
              rel="noreferrer"
            >
              Depact KJSIEIT
                </a>
          </div>
        </Col>
        <Col xl="6">
          <Nav className="nav-footer justify-content-center justify-content-xl-end">
            <NavItem>
              <NavLink
                href="#"
              >
                By 
                  </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="#"
              >
                Vivek
                  </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="#"
              >
                Ashish
                  </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="#"
              >
                Vighnesh
                  </NavLink>
            </NavItem>
          </Nav>
        </Col>
      </Row>
    </footer>
  );
};

export const mapStateToProps = state => {
  // console.log("this is the state", state);
  return {
    adminValue: state.switchRoutes.admin,
    userValue: state.switchRoutes.user,
    username: state.userName,
    fullname: state.tempUser,
    theme: state.theme,
    text: state.text,
  }
}

export default connect(mapStateToProps)(Footer);
